export default "__VITE_ASSET__BoV9GKZ1__"